export enum bookingSteps {
  search = 'search',
  chooseRoom = '',
  meetingRoom = 'meeting-room',
  checkout = 'checkout',
}

export enum bookingStepTitles {
  chooseRoom = 'Choose a room',
  roomServices = 'Select Room Services',
  checkout = 'Checkout',
}

export enum checkoutTypes {
  guestCheckout = 'guest',
  createAccount = 'create-account',
  checkoutDetails = 'user',
}

export enum checkoutSteps {
  roomServices = 'room-services',
  orderRoom = 'order-room',

  accountSelection = 'account-selection',
  details = 'details', // user details form
  payment = 'payment',
  confirmation = 'confirmation', // thank you page
}
// New MR steps flow
export enum NavigationSteps {
  chooseRoom = 'choose-room',
  roomServices = 'room-services',
  checkout = 'checkout',
}

